export enum GeoIpTypes {
  // GEO IP COUNTRY
  GEO_IP_COUNTRY__REQUEST = 'GEO_IP_COUNTRY__REQUEST',
  GEO_IP_COUNTRY__SUCCESS = 'GEO_IP_COUNTRY__SUCCESS',
  GEO_IP_COUNTRY__ERROR = 'GEO_IP_COUNTRY__ERROR',

  GEO_IP_COUNTRY_BLOCKED = 'GEO_IP_COUNTRY_BLOCKED',
}
